export default __webpack_public_path__ + "static/media/bg1.a8c5b07f.jpg";